/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import { InspectorHomeAction, InspectorHomeActionType } from '../actions/inspectorHomeActions';
import { MainStatisticsDto } from '../api/mainStatistics/mainStatisticsClient.typings';
import { SSEErrorType } from '../middlewares/SSEMiddelware';

export interface InspectorHomeState {
    mainStat: MainStatisticsDto;
    error: SSEErrorType;
    isOpenSSE: boolean;
}

const initialState: InspectorHomeState = {
    error: null,
    isOpenSSE: false,
    mainStat: {
        year: {
            cashBoxes: 0,
            vatSum: 0,
            docCount: 0,
            turnover: 0,
        },
        today: {
            cashBoxes: 0,
            vatSum: 0,
            docCount: 0,
            turnover: 0,
        },
    },
};

export function inspectorHomeReducer(
    state: InspectorHomeState = initialState,
    action: InspectorHomeAction,
): InspectorHomeState {
    switch (action.type) {
        case InspectorHomeActionType.SSE_ON_MESSAGE:
            const mainStat = action.payload;

            return {
                ...state,
                mainStat,
            };

        case InspectorHomeActionType.SSE_OPEN:
            return {
                ...state,
                isOpenSSE: true,
                error: null,
            };

        case InspectorHomeActionType.SSE_ERROR:
            return {
                ...state,
                isOpenSSE: false,
                error: action.payload,
            };

        case InspectorHomeActionType.SSE_CLOSED:
            return {
                ...initialState,
            };
    }
    return state;
}
